// extracted by mini-css-extract-plugin
export default {"freeContainer":"_ebf82f28","costContainer":"_a2d09d37"};